
import { ControllerLogEntry } from '@/api/dtos/LogEntry.schema'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ControllerLogEntryContent extends Vue {
  @Prop()
  logEntry!: ControllerLogEntry
}
